export const getReservationDoorCode = (reservation = {}) =>
  reservation.door_code_manual ||
  reservation.manual_door_code ||
  reservation.door_code ||
  "";
